import { FormControl, FormControlProps, InputLabel, Select } from '@mui/material'
import React, { PropsWithChildren, ReactElement } from 'react'
import { Controller, RegisterOptions, useFormContext } from 'react-hook-form'

type ReactHookFormSelectProps = FormControlProps & {
  name: string
  label: string
  defaultValue?: string | number
  rules?: RegisterOptions
}

export default function ReactHookFormSelect({
  name,
  label,
  defaultValue,
  children,
  rules,
  ...props
}: PropsWithChildren<ReactHookFormSelectProps>): ReactElement {
  const labelId = `${name}-label`
  const { control } = useFormContext()
  return (
    <FormControl {...props}>
      <InputLabel id={labelId}>{label}</InputLabel>
      <Controller
        control={control}
        name={name}
        rules={rules}
        defaultValue={defaultValue}
        render={({ field }) => (
          <Select {...field} labelId={labelId} label={label}>
            {children}
          </Select>
        )}
      />
    </FormControl>
  )
}
